module.exports = __webpack_public_path__ + "img/about1.0c307140.png";